import { styled } from "styled-components";

export const CallRatesSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${({ theme }) =>
    `linear-gradient(to bottom, ${theme.colors.primary[950]} 200px, ${theme.colors.base} 0)`};
  position: relative;
  overflow: hidden;
  @media (min-width: 2400px) {
    background: ${({ theme }) =>
      `linear-gradient(to bottom, ${theme.colors.primary[950]} 150px, ${theme.colors.base} 0)`};
  }
`;

export const CallRatesSearchContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
`;

export const Arch = styled.div`
  z-index: 0;
  color: ${({ theme }) => theme.colors.base};
  overflow-x: hidden;
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: -1px;

  @media (min-width: 2400px) {
    display: none;
  }
`;
